export class ThreadHistory {
    constructor({
          id= null, 
          status= ``, 
          log= ``, 
          process= ``,
          startDate= ``, 
          endDate= ``,
          totalItems= ``, 
          successCount= ``, 
          errorCount= ``,
          threadGroup= ``, 
          threadSummary= ``
      } = {}) {
      this.id = id;
      this.status = status;
      this.log = log;
      this.process = process;
      this.startDate = startDate;
      this.endDate = endDate;
      this.totalItems = totalItems;
      this.successCount = successCount;
      this.errorCount = errorCount;
      this.threadGroup = threadGroup;
      this.threadSummary = threadSummary;
    }
  }
  export function newEntity() {
    return new ThreadHistory();
  }
  export function gridFields() {
    return Object.freeze([
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          form: {
              type: 'processingStatus'
          }
        },
        {
          key: 'logAvailable',
          label: 'Log',
          sortable: true,
          form: {
            type: 'log'
          }
        },
        {
          key: 'id',
          label: 'Id',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'processExecution.processDefinition.name',
          label: 'Process',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'startDate',
          label: 'Start Date',
          sortable: true,
          form: {
            type: 'datetimepicker'
          }
        },
        {
          key: 'endDate',
          label: 'End Date',
          sortable: true,
          form: {
            type: 'datetimepicker'
          }
        },
        {
          key: 'totalCount',
          label: 'Scheduled',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'successCount',
          label: 'Success',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'errorCount',
          label: 'Error',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'processExecution.id',
          label: 'Thread Group',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'summary',
          label: 'Thread Summary',
          sortable: true,
          form: {
            type: 'input'
          }
        }     
    ]);
  }
  export const fields = Object.freeze(Object.keys(new ThreadHistory()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.processFilter',
    'filter.fromFilter',
    'filter.toFilter',
    'filter.statusFilter',
    'filter.threadGroupFilter',
    'filter.threadSummaryFilter',
    'filter.threadIdFilter'
  ];
  export const filter = {
    'processFilter': "",
    'fromFilter': "",
    'toFilter': "",
    'statusFilter': "",
    'threadGroupFilter': "",
    'threadSummaryFilter': "",
    'threadIdFilter': ""
  };